import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const CommsTopicRoleModelSchema = z
  .object({
    id: z.string(),
    comms_topic_id: z.string(),
    account_role_choice_id: z.string()
  })
  .strict()

const CommsTopicRoleModelFields = makeFieldKeys(CommsTopicRoleModelSchema)

export type CommsTopicRoleModel = z.infer<typeof CommsTopicRoleModelSchema>

function validateCommsTopicRoleModel(data: unknown): CommsTopicRoleModel {
  try {
    return validateWithZodSchema(CommsTopicRoleModelSchema, data, 'comms topic role model')
  } catch (error) {
    throw new Error(`Comms topic role model validation failed: ${error}`)
  }
}
